"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactModal = require("react-modal");

var _reactModal2 = _interopRequireDefault(_reactModal);

var _Flex = require("../Flex");

var _Flex2 = _interopRequireDefault(_Flex);

var _Box = require("../Box");

var _Box2 = _interopRequireDefault(_Box);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const customStyles = {
  overlay: {
    backgroundColor: "rgba(33, 37, 48, 0.8)",
    zIndex: 2
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    borderRadius: 4,
    padding: 0
  }
};

_reactModal2.default.setAppElement("body");

const Modal = ({ width, isOpen, closeModal, children }) => _react2.default.createElement(
  _reactModal2.default,
  { isOpen: isOpen, onRequestClose: closeModal, style: customStyles },
  _react2.default.createElement(
    Modal.Wrapper,
    { width: width },
    children
  )
);

Modal.Wrapper = (0, _styledComponents2.default)(_Box2.default).withConfig({
  displayName: "Modal__Wrapper",
  componentId: "sc-1d6kgvo-0"
})([""]);
Modal.Wrapper.defaultProps = {
  width: 600
};

Modal.propTypes = {
  isOpen: _propTypes2.default.bool,
  closeModal: _propTypes2.default.func,
  children: _propTypes2.default.node,
  width: _propTypes2.default.number
};

Modal.Header = (0, _styledComponents2.default)(_Flex2.default).withConfig({
  displayName: "Modal__Header",
  componentId: "sc-1d6kgvo-1"
})([""]);
Modal.Header.defaultProps = {
  pt: 3,
  pr: 3,
  pb: 3,
  pl: 3,
  borderBottom: 1,
  borderColor: "palette.ink.300",
  flexDirection: "column"
};

Modal.Content = (0, _styledComponents2.default)(_Box2.default).withConfig({
  displayName: "Modal__Content",
  componentId: "sc-1d6kgvo-2"
})([""]);
Modal.Content.defaultProps = {
  pt: 3,
  pr: 3,
  pb: 3,
  pl: 3
};

Modal.Actions = (0, _styledComponents2.default)(_Flex2.default).withConfig({
  displayName: "Modal__Actions",
  componentId: "sc-1d6kgvo-3"
})([""]);
Modal.Actions.defaultProps = {
  pt: 3,
  pr: 3,
  pb: 3,
  pl: 3,
  borderTop: 1,
  borderColor: "palette.ink.300",
  alignItems: "center"
};

exports.default = Modal;